import { render } from "./nest_consumer_detail.vue?vue&type=template&id=0cb42d42"
import script from "./nest_consumer_detail.vue?vue&type=script&lang=js"
export * from "./nest_consumer_detail.vue?vue&type=script&lang=js"

import "./nest_consumer_detail.vue?vue&type=style&index=0&id=0cb42d42&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__